import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { RootState } from "../../../store/store";
import Dashboardpages from "../../../components/dashboardpages/dashboardpages";
import { Tour, TourProps } from "antd";
import { useDispatch } from "react-redux";
import { updateShowTour } from "../../../store/appSlice/appSlice";
import Touritem from "../student/tourstart/touritem/touritem";
import Tourstart from "../student/tourstart/tourstart";
import Tourend from "../student/tourstart/tourend";
import { updateUserDoneOnboardingTour } from "../../../api/user/user";
import { updateUser } from "../../../store/userSlice/userSlice";

const Teacher = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const [currentTourNumber, setCurrentTourNumber] = useState(0);
  const [showTourEnd, setShowTourEnd] = useState(false);

  const effectUpdateShowTour = (value: boolean) => {
    dispatch(
      updateShowTour({
        showTour: value,
      })
    );
  };

  const state = useSelector((state: RootState) => ({
    showTour: state.app.showTour,
    user: state.user.user,
  }));

  const { showTour, user } = state;

  // all on student dashboard
  const lilyRef = useRef(null);
  const openLilyRef = useRef(null);
  const dashboardRef = useRef(null);
  const curriculaRef = useRef(null);
  const classesRef = useRef(null);
  const studentsRef = useRef(null);
  const settingsRef = useRef(null);

  const steps: TourProps["steps"] = [
    {
      title: null,
      description: (
        <Touritem
          backdrop={`/img/vectors/biglily.svg`}
          subtitle={`1 of 7`}
          title={`Meet your tutor`}
          desc={
            <div>
              You have a learning buddy! <br />
              Your AI tutor is here to monitor your students' progress and answer 
              any questions you might have.
            </div>
          }
          hasPrev={false}
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "right",
      target: () => lilyRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          backdrop={`/img/vectors/biglily.svg`}
          subtitle={`2 of 7`}
          title={`Pick your buddy`}
          desc={
            <div>
              You can access the tutor panel and student stats from your AI buddy.
              <br />
              There’s a variety of fun tutors with their own special quirks!
            </div>
          }
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "right",
      target: () => openLilyRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          tourbgClass="custom-orange-spiral-bg-linear"
          backdrop={`/img/vectors/tourhome.svg`}
          subtitle={`3 of 7`}
          title={`Your Dashboard`}
          desc={
            <div>
              You’ve got your own your home page! <br />
              You can view your curriculums, students and lesson plans!
            </div>
          }
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "rightBottom",
      target: () => dashboardRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          tourbgClass="custom-orange-spiral-bg-linear"
          backdrop={`/img/vectors/tourlessons.svg`}
          subtitle={`4 of 7`}
          title={`My Curricula`}
          desc={<div>Here you can view available currciulum content and 
            create your own curriculum for teachers</div>}
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "rightBottom",
      target: () => curriculaRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          backdrop={`/img/vectors/biglily.svg`}
          subtitle={`5 of 7`}
          title={`My Classes`}
          desc={<div>Create, edit and view your classes, add students. 
            You can also add supporting teachers to your class.</div>}
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "rightBottom",
      target: () => classesRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          tourbgClass="custom-orange-spiral-bg-linear"
          backdrop={`/img/vectors/tourramruns.svg`}
          subtitle={`6 of 7`}
          title={`My Students`}
          desc={<div>View student stats and overall student progress.
            Identify students areas of strengths and weaknesses.
          </div>}
          nextAction={() => {
            setCurrentTourNumber(currentTourNumber + 1);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "right",
      target: () => studentsRef.current,
    },
    {
      title: null,
      description: (
        <Touritem
          tourbgClass="custom-orange-spiral-bg-linear"
          backdrop={`/img/vectors/toursettings.svg`}
          subtitle={`7 of 7`}
          title={`Settings`}
          desc={
            <div>
              Manage your account here. You can manage your username and password
              and other account settings.
            </div>
          }
          nextAction={() => {
            setShowTourEnd(true);
            effectUpdateShowTour(false);
          }}
          prevAction={() => {
            setCurrentTourNumber(currentTourNumber - 1);
          }}
          skipAction={() => {
            effectUpdateShowTour(false);
          }}
        />
      ),
      placement: "right",
      target: () => settingsRef.current,
    },
    // {
    //   title: null,
    //   description: <Touritem
    //     tourbgClass='custom-orange-spiral-bg-linear'
    //     backdrop={`/img/vectors/tourdone.svg`}
    //     subtitle={`9 of 9`}
    //     title={`You’re all set!`}
    //     desc={
    //       <div>
    //         You just finished taking the welcome tour and now you’re armed with all the knowledge you need to start your journey!
    //       </div>
    //     }
    //     nextAction={() => {
    //       setCurrentTourNumber(currentTourNumber + 1)
    //     }}
    //     prevAction={() => {
    //       setCurrentTourNumber(currentTourNumber - 1)
    //     }}
    //     skipAction={() => {
    //       effectUpdateShowTour(false)
    //     }}
    //     isTourEnd={true}
    //   />,
    //   placement: 'top',
    //   target: null,
    // },
  ];

  const runTourEnd = async () => {
    try {
      await updateUserDoneOnboardingTour({
        doneOnboardingTour: true,
      });
      dispatch(
        updateUser({
          user: {
            ...user,
            doneOnboardingTour: true,
          },
        })
      );
    } catch (error) {}
  };

  const effectUpdateShowTourEnd = (value: boolean) => {
    setShowTourEnd(value);
    if (user?.doneOnboardingTour !== true) {
      runTourEnd();
    }
  };

  return (
    <div>
      <Dashboardpages
        refs={[
          {
            belongsTo: "lily",
            refValue: lilyRef,
          },
          {
            belongsTo: "openLily",
            refValue: openLilyRef,
          },
          {
            belongsTo: "Dashboard",
            refValue: dashboardRef,
          },
          {
            belongsTo: "My Curricula",
            refValue: curriculaRef,
          },
          {
            belongsTo: "My Classes",
            refValue: classesRef,
          },
          {
            belongsTo: "My Students",
            refValue: studentsRef,
          },
          {
            belongsTo: "Settings",
            refValue: settingsRef,
          },
        ]}
        currentTourNumber={currentTourNumber}
      >
        <Outlet />

        <Tourstart effectUpdateShowTour={effectUpdateShowTour} />

        {showTourEnd ? (
          <Tourend effectUpdateShowTour={effectUpdateShowTourEnd} />
        ) : null}

        <Tour
          current={currentTourNumber}
          open={showTour}
          onClose={() => {
            effectUpdateShowTour(false);
          }}
          steps={steps}
          onChange={(current: number) => {
            setCurrentTourNumber(current);
          }}
        />
      </Dashboardpages>
    </div>
  );
};

export default Teacher;
